import DeliveryTruckIcon from './DeliveryTruckIcon';

export default DeliveryTruckIcon;
